<section class="lp-countries-advantages">
    <div class="row">
      <div class="col-12">
        <div class="lp-countries-advantages-wrapper">
          <div *ngFor="let advantage of advantages" class="lp-countries-advantages-card">
            <div class="lp-countries-advantage-image">
              <img src="{{ advantage?.image }}" alt="Shippn parcel forwarding advantages, saving money, reducing cost" />
            </div>
            <div class="lp-countries-advantage-title">
                <h6>
                    {{advantage?.title}}
                </h6>
            </div>
            <div class="lp-countries-advantage-content">
                <p>
                    {{advantage?.content}}
                </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  